// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,

  auth: {
    url: 'https://api.realplazalabs.com/v1/identity',
    client_id: 'realplaza.softwareintegrador',
    client_secret: '3CD98E07-77EF-49ED-8870-7401B6A5585A',
    scope: 'ms-rp-budgets ms-rp-filestorage ms-rp-workflowmanager ms-rp-nps offline_access',
    grand_type: 'password',
  },

  oauth_setting : {
    authority: 'https://login.microsoftonline.com/557a1186-a623-4056-845f-57076190d7a8',
    appId: 'cf41abe8-e44d-43a5-b287-02a2fc48a315',
    scope_name: 'api-ppto-planilla',
    todolist: 'https://buildtodoservice.azurewebsites.net/api/todolist',
    graph_me: 'https://graph.microsoft.com/v1.0/me',
    tenantId: '557a1186-a623-4056-845f-57076190d7a8',
    options_365: 'user.read',
    redirect_uri: 'https://planilla.realplazalabs.com/auth/verificacion',
	secret_identifier_uri: 'P_SECRET_IDENTIFIER_URI',
    scopes: [
        'user.read',
        'calendars.read'
    ]
  },

  // tiempo en segundos
  times: {
    timeAuthy: 120,
    timeSession: 300,
  },

  api_main : 'https://api.realplazalabs.com/business/payroll/',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
